export default __webpack_public_path__ + "measure-800-c1bcff1e776b62e67ed285b5cc199981.png";